import React, { Component } from 'react';
import './Banner.scss';

class Banner extends Component {
  render() {
    return (
      <section className="banner" role="banner">
        <div className="container">
          <div className="col-md-10 col-md-offset-1">
            <div className="banner-text text-center">
              <h1>3D Design Studio</h1>
              <p>We are providing service of 3D low poly modeling, rigging, animating for games</p>
              <a target="_blank" href="https://www.deviantart.com/denisdrakulla/gallery/" className="btn btn-large">See on Deviant</a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;
